








interface ComponentData {
    breakpoint: Breakpoint;
    isMobile: boolean
}

import Vue from 'vue'
import {Breakpoint, mqMaxWidth} from "@/util/mq";

export default Vue.extend({
    name: 'DesktopMobileSwitch',
    data(): ComponentData {
        return {
            isMobile: mqMaxWidth('lg').matches || false,
            breakpoint: 'lg'
        }
    },
    methods: {
        handleResize() {
            this.isMobile = mqMaxWidth(this.breakpoint).matches || false;
        }
    },
    created() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    }
})
